import { Injectable } from '@angular/core';
import { UserDetails } from '@innovation-os-ng/core/models';
import { firstValueFrom } from 'rxjs';
import { UserProfileServiceContract } from '../contracts/user-profile-service.contract';
import { RestApiService } from '../stubs/rest-api-service.stub';

/**
 * Provides methods to retrieve information about users.
 */
@Injectable()
export class UserProfileService extends RestApiService implements UserProfileServiceContract {
  private cachedUsersDetails: { [key: string]: Promise<UserDetails> } = {};

  /**
   * Returns whether a user with the given email address exists or not.
   *
   * @param email The email address, which should be checked.
   */

  /**
   * Returns updated user information.
   *
   * @param userDetails User details that is to be updated.
   * @param accessToken access token.
   */

  public async updateUserInformation(userDetails: UserDetails, accessToken: string): Promise<UserDetails> {
    const userDataWithAccessToken = {
      ...userDetails,
      accessToken
    };
    try {
      const updateDetailsPromise = firstValueFrom(
        this.httpClient.put<UserDetails>(`${this.restUrl}/users/users/${userDetails.userUri} `, userDataWithAccessToken)
      );
      const response = await updateDetailsPromise;
      // lets keep our cache updated with updated details
      this.cachedUsersDetails[response.userUri] = updateDetailsPromise;
      return response;
    } catch (error) {
      this.convertToException(error);
    }
  }

  /**
   * Returns user detail for given user uri
   *
   * @param userUri User uri for which details is to be fetched.
   */

  public getUser(userUri: string): Promise<UserDetails> {
    try {
      if (!this.cachedUsersDetails[userUri]) {
        this.cachedUsersDetails[userUri] = firstValueFrom(this.httpClient.get<UserDetails>(`${this.restUrl}/users/users/${userUri} `));
      }
      return this.cachedUsersDetails[userUri];
    } catch (error) {
      this.convertToException(error);
    }
  }
}
